<template>
  <vs-table hover-flat v-if="messages && messages.length" :data="messages">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$tc('message', 3)"></vs-th>
      <vs-th v-text="$t('agent')"></vs-th>
      <vs-th v-text="$t('sender')"></vs-th>
      <vs-th v-text="$t('receiver')"></vs-th>
      <vs-th v-text="$t('result')"></vs-th>
      <vs-th v-text="$t('types')"></vs-th>
      <vs-th v-text="$t('sent_at')"></vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td style="max-width: 200px;" v-text="tr.count" :data-tr-title="$tc('message', 3)">
          <vs-textarea readonly v-model="tr.content"/>
        </vs-td>
        <vs-td v-text="tr.agent_name" :data-tr-title="$t('agent')"></vs-td>
        <vs-td v-text="tr.sender" :data-tr-title="$t('sender')"></vs-td>
        <vs-td v-text="tr.receiver" :data-tr-title="$t('receiver')"></vs-td>
        <vs-td :data-tr-title="$t('result')">
          <badge-sms-result :content="tr.result"></badge-sms-result>
        </vs-td>
        <vs-td :data-tr-title="$t('types')">
          <badge-sms-type :content="tr.type"></badge-sms-type>
        </vs-td>
        <vs-td :data-tr-title="$t('sent_at')">{{ tr.sent_at | readableDate }}</vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
import BadgeSmsResult from '@/components/badge/SmsResult'
import BadgeSmsType from '@/components/badge/SmsType'

export default {
  name: 'Shared.Messages.History.List',
  components: {
    BadgeSmsType,
    BadgeSmsResult
  },
  props: {
    messages: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style lang="scss">

</style>
